import React, { useState } from "react";
import { Country as CountryStateCity } from 'country-state-city'; 

const CountrySelect = ({props, onSelectedCountry, selectedCountry}) => { 
  // const [selectedCountry, setSelectedCountry] = useState('');

  // const handleCountryChange = (event) => {
  //   setSelectedCountry(event.target.value);
  //   if (props.onCountryChange) {
  //     props.onCountryChange(event.target.value);
  //   }
  // };

  return (
    <div className="pb-2 ml-3 mb-2">
      <select
        id="country"
        value={selectedCountry}
        onChange={onSelectedCountry}
        className="border border-gray-300 bg-white  text-xs text-grey-700 py-1 pl-3 pr-8 leading-tight rounded-lg focus:outline-none"
      >
        <option value=''>Select Country</option>
        {CountryStateCity.getAllCountries().map((country, index) => (
          <option key={index} value={country.name}>
            {country.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CountrySelect;
